// extracted by mini-css-extract-plugin
export default {"formButton":"FormButton_formButton__+6HRv","multiColorButton":"FormButton_multiColorButton__jv60e","whiteButton":"FormButton_whiteButton__0TVQh"};